"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent, CardDescription, CardTitle } from "@/components/ui/card";
import { BookOpen, Brain, GraduationCap, Laptop } from "lucide-react";
export default function OurServicesOverview() {
  const {
    ref: card1Ref,
    isVisible: card1Visible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: card2Ref,
    isVisible: card2Visible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: card3Ref,
    isVisible: card3Visible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const services = [{
    icon: BookOpen,
    title: "KS3, GCSE and A-Level Tutoring",
    description: "Expert tutoring in Science, Maths, and English tailored to each student's learning style and pace.",
    ref: card1Ref,
    isVisible: card1Visible
  }, {
    icon: Brain,
    title: "Confidence & Mindset Coaching",
    description: "Build exam confidence, improve focus, and develop resilience through proven coaching techniques.",
    ref: card2Ref,
    isVisible: card2Visible
  }, {
    icon: GraduationCap,
    title: "Online Courses & Digital Learning",
    description: "Explore engaging online courses and digital resources designed to boost your learning experience.",
    ref: card3Ref,
    isVisible: card3Visible
  }];
  return <section className="bg-background py-16 px-4 md:px-6 lg:px-8">
      <div className="mx-auto max-w-7xl">
        <div className="mb-12 text-center">
          <h2 className="font-display text-3xl font-semibold text-primary md:text-4xl">
            Our Services Overview
          </h2>
          <p className="text-muted-foreground mt-3 text-lg">
            Combining expert tutoring with confidence coaching for lasting results
          </p>
        </div>

        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          {services.map((service, i) => {
          const IconComponent = service.icon;
          return <div key={i} data-index={i} ref={service.ref} className={`group transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] ${service.isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
                <Card className="h-full border border-border shadow-soft transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-1 hover:shadow-medium">
                  <CardContent className="flex flex-col items-center gap-4 text-center">
                    <div className="rounded-lg bg-primary/10 p-4 transition-transform duration-[var(--duration-medium)] ease-[var(--ease-spring)] group-hover:scale-105">
                      {i === 2 ? <Laptop className="h-8 w-8 text-primary" strokeWidth={1.5} /> : <IconComponent className="h-8 w-8 text-primary" strokeWidth={1.5} />}
                    </div>
                    <div>
                      <CardTitle className="mb-2 text-xl text-primary">
                        {service.title}
                      </CardTitle>
                      <CardDescription className="text-foreground/80 leading-relaxed">
                        {service.description}
                      </CardDescription>
                    </div>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}